const initialState = {
    content: {},

};

const editOrder = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_EDIT_ORDER':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default editOrder;
